import React, { useEffect } from "react";
import { PointLight as PointLightImpl } from "three";
import { PointLightConfig } from "../LightConfig";
import { applyShadowSettings } from "@/utils/shadow";

type Props = {
    config: PointLightConfig;
    drawHelpers?: boolean;
};

export const PointLight: React.FC<Props> = ({ config, drawHelpers }) => {
    const ref = React.useRef<PointLightImpl>(null);
    useEffect(() => {
        if (ref.current) {
            applyShadowSettings(ref.current.shadow);
        }
    }, [ref.current]);

    return (
        <>
            <pointLight
                ref={ref}
                position={config.position}
                intensity={config.intensity}
                color={config.color}
                distance={config.distance}
                castShadow={config.castShadow}
            />
            <mesh visible={drawHelpers} position={config.position}>
                <sphereGeometry args={[0.1, 16, 16]} />
                <meshStandardMaterial color="yellow" />
            </mesh>
        </>
    );
};
